// The icon set, drawn here rather than installed.
//
// An icon package would be a dependency decision; a handful of paths is not worth one. They are
// stroked with currentColor so an icon follows the palette of whatever control holds it, and they
// are aria-hidden because the control carries the accessible name - an icon-only button without
// one is a button nobody can name, to a screen reader or to a test.

const PATHS = {
  plus: <path d="M8 3v10M3 8h10" />,
  pencil: (
    <>
      <path d="M11.5 2.5a1.4 1.4 0 0 1 2 2L6 12l-3 1 1-3z" />
      <path d="M10.5 3.5 12.5 5.5" />
    </>
  ),
  download: (
    <>
      <path d="M8 2v8" />
      <path d="M4.5 7 8 10.5 11.5 7" />
      <path d="M3 13h10" />
    </>
  ),
  upload: (
    <>
      <path d="M8 12V4" />
      <path d="M4.5 7 8 3.5 11.5 7" />
      <path d="M3 13h10" />
    </>
  ),
  trash: (
    <>
      <path d="M3 4.5h10M6.5 4.5v-2h3v2M4.5 4.5l.7 9h5.6l.7-9" />
      <path d="M6.7 7v4.5M9.3 7v4.5" />
    </>
  ),
  paperclip: (
    <path d="M10.5 5.5 6 10a1.5 1.5 0 0 0 2.1 2.1l5-5a3 3 0 0 0-4.2-4.2l-5.3 5.3a4.5 4.5 0 0 0 6.4 6.4L13 11.6" />
  ),
  menu: <path d="M2.5 4h11M2.5 8h11M2.5 12h11" />,
  close: <path d="M4 4l8 8M12 4l-8 8" />,
  funnel: <path d="M2.5 3h11L9.5 8v4.5l-3 1.5V8z" />,
  previous: <path d="M10 3 5 8l5 5" />,
  next: <path d="M6 3l5 5-5 5" />,
  down: <path d="M3.5 6 8 10.5 12.5 6" />,
  signOut: (
    <>
      <path d="M6 2H3v12h3" />
      <path d="M9 5l3 3-3 3" />
      <path d="M12 8H6" />
    </>
  ),
  settings: (
    <>
      <circle cx="8" cy="8" r="2" />
      <path d="M6.95 2.6 7.2 1.45 8.8 1.45 9.05 2.6 11.08 3.44 12.06 2.8 13.2 3.94 12.56 4.92 13.4 6.95 14.55 7.2 14.55 8.8 13.4 9.05 12.56 11.08 13.2 12.06 12.06 13.2 11.08 12.56 9.05 13.4 8.8 14.55 7.2 14.55 6.95 13.4 4.92 12.56 3.94 13.2 2.8 12.06 3.44 11.08 2.6 9.05 1.45 8.8 1.45 7.2 2.6 6.95 3.44 4.92 2.8 3.94 3.94 2.8 4.92 3.44z" />
    </>
  ),
  copy: (
    <>
      <rect x="5" y="5" width="8" height="8" rx="1" />
      <path d="M3 11V3a1 1 0 0 1 1-1h8" />
    </>
  ),
  check: <path d="M3.5 8.5 6 11l6.5-6.5" />,
  help: (
    <>
      <circle cx="8" cy="8" r="6.5" />
      <path d="M6.1 6.2a1.95 1.95 0 1 1 2.7 1.8c-.5.2-.8.6-.8 1.1v.5" />
      <path d="M8 11.4v.3" />
    </>
  ),
  bell: (
    <>
      <path d="M8 1.5a4 4 0 0 0-4 4v2.5L2.5 10.5v1h11v-1L12 8V5.5a4 4 0 0 0-4-4z" />
      <path d="M6.5 12.5a1.5 1.5 0 0 0 3 0" />
    </>
  ),
  mic: (
    <>
      <rect x="6" y="1.5" width="4" height="8" rx="2" />
      <path d="M3.5 7.5a4.5 4.5 0 0 0 9 0M8 12v2.5" />
    </>
  ),
  stop: <rect x="4" y="4" width="8" height="8" rx="1.5" />,
  play: <path d="M5 3.5v9l7-4.5z" />,
};

export default function Icon({ name }) {
  return (
    <svg className="icon" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
      {PATHS[name]}
    </svg>
  );
}
